// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3833":"818733ca","7699":"bf75d796"}[chunkId] + ".chunk.css";
};